export const STANDALONE_CONTENT_FOLDER = 'reportcontent'
export const STANDALONE_DATA_FOLDER = `${STANDALONE_CONTENT_FOLDER}/data`
export const STANDALONE_REFERENCE_DATA = `${STANDALONE_CONTENT_FOLDER}/report-reference-data`
